import {
  clientPaths,
  isPath,
  isPathPrefix,
  isPublicProfilePath,
  normalizePathname,
} from '@/utils/clientPaths';

/** Paths guests may open without login (Apple review / guest home). */
export function isPublicCustomerPath(pathname: string): boolean {
  const path = normalizePathname(pathname);

  if (path === '/' || isPath(path, clientPaths.home) || path === '/client') {
    return true;
  }

  if (isPathPrefix(path, clientPaths.discovery.root)) {
    return true;
  }

  if (isPath(path, clientPaths.mmr.leaderboard)) {
    return true;
  }

  // Public player profile — not /profile settings or nested account tools
  if (isPublicProfilePath(path)) {
    return true;
  }

  // Event detail only — not list, create, checkout, or nested tools
  const eventDetail = path.match(/^\/event\/([^/]+)$/);
  if (eventDetail) {
    const reserved = new Set(['create', 'edit', 'dashboard', 'checkout']);
    if (!reserved.has(eventDetail[1])) {
      return true;
    }
  }

  if (/^\/community\/[^/]+(\/(members|events))?$/.test(path)) {
    return true;
  }

  return false;
}
